var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil1 {fill:#1C1B17}\n    .fil0 {fill:#FFD900}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M166 203l-128 0c-21,0 -38,-17 -38,-37l0 -128c0,-21 17,-38 38,-38l128 0c20,0 37,17 37,38l0 128c0,20 -17,37 -37,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M203 79l0 56c-15,16 -32,25 -50,20 -30,-10 -27,-41 -25,-54l-45 72 -37 -13 6 -48 -51 68c-1,-3 -1,-6 -1,-10l0 -47 52 -67 35 12 -6 44 49 -80 41 14 0 1c-7,26 -19,68 -6,71 8,2 23,-15 38,-39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYandex);
export default __webpack_public_path__ + "static/media/iconYandex.3c15f087ede99522d96be30ff90eb1c9.svg";
export { ForwardRef as ReactComponent };